import $ from 'jquery';
import { readStored, writeStored } from '../lib/storage';

// `currentLang` and `languageMap` are rendered by layout.antlers.html, the two
// translation tables by partial/_langmodal.antlers.html (as `const`, so they are
// reachable as globals but not as `window.` properties).

const STORAGE_KEY = 'language-banner-dismissed';

/**
 * "This page is also available in your language" banner (.modalLang) and the
 * language <select> in the header (#setLang).
 */
export function initLanguageBanner() {
    const userLang = navigator.language.slice(0, 2);
    const hasAlternative = languageMap[userLang];
    const dismissed = readStored(STORAGE_KEY);

    if (currentLang !== userLang && !dismissed && hasAlternative) {
        $('.modalLang').addClass('d-flex');
        $('.modalLang').removeClass('d-none');
        $('header').addClass('moveNav');

        $('#switchTranslation').text(switchLangTranslations[userLang]);
        $('#switchTranslationMobile').text(switchLangTranslations[userLang]);
        $('#buttonTranslation').text(continueTranslations[userLang]);

        $('#closeLangModal, #closeLangModalMobile').click(function () {
            $('.modalLang').addClass('d-none');
            $('header').removeClass('moveNav');
            writeStored(STORAGE_KEY, 'true');
        });

        $('#lang').val(userLang);
    }

    $('#setLang').submit(function (e) {
        e.preventDefault();
        const optionSelected = $('option:selected', this);

        writeStored(STORAGE_KEY, 'true');
        window.location.href = optionSelected.data('action');
    });
}
